import { createSlice } from "@reduxjs/toolkit";
import { BaseResponse } from "../../typings";
import { voidInvoiceAction } from "../actions/voidInvoiceAction";
import {
  IBillVoidResponse,
  IRefundInvoiceResponse,
} from "../../typings/interfaces/responses";
import { refundInvoiceAction } from "../actions/refundInvoiceAction";

interface VoidInvoiceState {
  voidInvoiceLoading: boolean;
  voidInvoiceError: string | null;
  voidInvoiceResponse: BaseResponse<IBillVoidResponse | null> | null;

  refundInvoiceLoading: boolean;
  refundInvoiceError: string | null;
  refundInvoiceResponse: BaseResponse<IRefundInvoiceResponse | null> | null;
}

const initialState: VoidInvoiceState = {
  voidInvoiceLoading: false,
  voidInvoiceError: null,
  voidInvoiceResponse: null,

  refundInvoiceLoading: false,
  refundInvoiceError: null,
  refundInvoiceResponse: null,
};

const invoiceSlice = createSlice({
  name: "invoice",
  initialState,
  reducers: {
    resetVoidInvoiceState: (state) => {
      state.voidInvoiceLoading = false;
      state.voidInvoiceError = null;
      state.voidInvoiceResponse = null;
    },
    resetRefundInvoiceState: (state) => {
      state.refundInvoiceLoading = false;
      state.refundInvoiceError = null;
      state.refundInvoiceResponse = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(voidInvoiceAction.pending, (state) => {
        state.voidInvoiceLoading = true;
        state.voidInvoiceError = null;
        state.voidInvoiceResponse = null;
      })
      .addCase(voidInvoiceAction.fulfilled, (state, action) => {
        state.voidInvoiceLoading = false;

        if (action.payload?.status === "FAILED") {
          state.voidInvoiceError = action.payload.message || "Void failed";
          state.voidInvoiceResponse = null;
        } else {
          state.voidInvoiceError = null;
          state.voidInvoiceResponse = action.payload;
        }
      })
      .addCase(voidInvoiceAction.rejected, (state, action) => {
        state.voidInvoiceLoading = false;
        state.voidInvoiceError = action.error.message ?? "Something went wrong";
        state.voidInvoiceResponse = null;
      });

    builder
      .addCase(refundInvoiceAction.pending, (state) => {
        state.refundInvoiceLoading = true;
        state.refundInvoiceError = null;
        state.refundInvoiceResponse = null;
      })
      .addCase(refundInvoiceAction.fulfilled, (state, action) => {
        state.refundInvoiceLoading = false;

        if (action.payload?.status === "FAILED") {
          state.refundInvoiceError = action.payload.message || "Refund failed";
          state.refundInvoiceResponse = null;
        } else {
          state.refundInvoiceError = null;
          state.refundInvoiceResponse = action.payload;
        }
      })
      .addCase(refundInvoiceAction.rejected, (state, action) => {
        state.refundInvoiceLoading = false;
        state.refundInvoiceError =
          action.error.message ?? "Something went wrong";
        state.refundInvoiceResponse = null;
      });
  },
});

export const { resetVoidInvoiceState } = invoiceSlice.actions;
export default invoiceSlice.reducer;
